<template>
  <div class="hello">

    <h1>Hyreshjälpen</h1>
    <p>Välkommen till <strong>hyreshjälpen</strong>, en sajt som finns till för att informera om vilka regler och lagar som gäller när man skall hyra eller hyra ut.</p>
    <p>Den extrema bostadsbrist som finns, framförallt i Stockholm, har gjort att många bor i tredje hand eller hyr svart. Många betalar oerhört höga hyror.</p>
    <p>I Sverige finns det lagar som reglerar uthyrning i andra hand, håll koll på dina rättigheter så att du slipper betala pengar i onödan.</p>

  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Hello.vue?00d2f1ec